import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class DebugService {
  constructor() {}

  consoleLog(value: string) {
    let debuglocal = localStorage.getItem("debug-dev");

    if (debuglocal !== null && debuglocal === "") {
      console.log(value);
    }
  }
}
